export const MANAGEMENT_VARIANT = {
  DEFAULT: "default",
  PRICE_ADJUSTMENT: "price-adjustment",
  HOMOLOGATION: "homologation",
  INDETERMINATE: "indeterminate",
};

// Parámetros para filtrar en el backend los productos sin tipo de gestión
// asignada y con gestión alerta "Sin Gestión".
export const SIN_TIPO_GESTION_ID = 5282;
export const SIN_GESTION_ALERTA_ID = 5272;

export const JUSTIFICACION_TECNICA_LABEL = "JUSTIFICACION TECNICA";
export const INDETERMINATE_LABEL = "INDETERMINADO";

export const isValidNewSalePrice = (value, record) => {
  if (value == null || value === "") return false;
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return false;
  const min = Number(record?.minimumPrice ?? 0);
  const max = Number(record?.maximumPrice ?? 0);
  return numeric >= min && numeric <= max;
};